import script from "./MintPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./MintPrice.vue?vue&type=script&setup=true&lang=js"

import "./MintPrice.vue?vue&type=style&index=0&id=0d41aedc&lang=scss"

export default script